import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { SearchComponent } from '../../components/common/search/search.component';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { IPage } from '../../models/common/paging';
import { AwardDto, CompetitorModalSearchModel } from '../../models/competitors/competitor.models';
import { CompetitorModalService } from '../../services/competitor.modal.service';
import { BaseCompetitorsComponent } from './base.competitors.component';

@Component({
    selector: 'competitor-modal',
    template: require('./competitor.modal.component.html')
})
export class CompetitorModalComponent extends SearchComponent<CompetitorModalSearchModel, AwardDto> implements OnInit, OnDestroy {

    base: BaseCompetitorsComponent;

    @Input() viewedCompany: string;
    @Input() elementId: string;
    response: IPage<AwardDto>;

    // Show/hide is driven entirely by Angular rather than the jQuery/Bootstrap modal plugin.
    // The plugin relies on being initialised against the real element id, which isn't reliably
    // available in time (elementId is an @Input, not set until after construction), leaving the
    // modal/backdrop unable to be dismissed. Controlling visibility directly avoids that issue.
    isOpen = false;

    constructor(private readonly competitorService: CompetitorModalService, configuration: Configuration, helpers: Helpers, private readonly elementRef: ElementRef) {
        super(new CompetitorModalSearchModel(configuration), competitorService, helpers);
    }

    ngOnInit() {
        super.ngOnInit();
        // Some ancestors (e.g. Material tab animations) apply a CSS transform, which makes them the
        // containing block for position:fixed descendants, preventing the modal from centering in the
        // real viewport. Moving the host node to document.body avoids that while Angular still tracks
        // and updates it normally via the component tree.
        document.body.appendChild(this.elementRef.nativeElement);
    }

    ngOnDestroy() {
        this.elementRef.nativeElement.remove();
    }

    showAndPopulate(companyName: string) {
        this.isOpen = true;
        $('body').addClass('modal-open');
        this.viewedCompany = companyName;
        this.request.name = companyName;
        this.request.pageSize = 5;
        this.search();
    }

    clearAndHide() {
        this.isOpen = false;
        $('body').removeClass('modal-open');
        this.viewedCompany = null;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/competitor.modal.component.ts